import React, { Component } from "react";
import "./Button.scss";

class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      onClick,
      className,
      children,
      style
    } = this.props
    return (
      <button
        className={className}
        onClick={onClick}
        style={style}
      >
        {children}
      </button>
    );
  }
}
export default Button;
